import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./auth";
import SeoHelmet from "./seo/SeoHelmet";

const LoginPage = () => {
  const { login, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from?.pathname || "/";

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    const result = await login(username.trim(), password);
    if (result.ok) {
      navigate(from, { replace: true });
    } else {
      setError(result.message);
    }
    setSubmitting(false);
  };

  if (!loading && isAuthenticated) {
    navigate(from, { replace: true });
    return null;
  }

  return (
    <>
      <SeoHelmet
        title="Sign In | Cyberpunk"
        description="Sign in to the authorized Cyberpunk case-management workspace."
        canonical="https://www.cyberpunk.pk/login"
        ogType="website"
      />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.default",
          p: 2,
        }}
      >
        <Card sx={{ width: "100%", maxWidth: 420 }} elevation={2}>
          <CardContent>
            <Stack spacing={2}>
              <Typography variant="h5" component="h1">
                CDR Analyzer | CDR Analysis | Call Detail Record Analysis
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sign in with your username and password.
              </Typography>
              <Box component="form" onSubmit={handleSubmit}>
                <Stack spacing={2}>
                  <TextField
                    label="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                    required
                    fullWidth
                  />
                  <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                    fullWidth
                  />
                  {error && (
                    <Typography variant="body2" color="error">
                      {error}
                    </Typography>
                  )}
                  <Button type="submit" variant="contained" disabled={submitting}>
                    {submitting ? (
                      <Stack direction="row" spacing={1} alignItems="center">
                        <CircularProgress size={16} />
                        <span>Signing in...</span>
                      </Stack>
                    ) : (
                      "Sign In"
                    )}
                  </Button>
                </Stack>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default LoginPage;
